import { ServiceField } from '@onlog-public/additional-services-types';

/**
 * getLoadTypes формирует типы для загрузки опций на основе полей
 *
 * @param fields
 */
export const getLoadTypes = (fields: ServiceField[]) => {
  return fields
    .map((field) => {
      if (['switch', 'hidden', 'number'].includes(field.type)) {
        return;
      }

      let loadingID =
        field.handbook_limitations.length > 0 ? field.handbook_limitations : undefined;

      if (field.type === 'handbook') {
        loadingID = [String(field.handbook_id)];
      }

      if (field.type === 'location' && !loadingID) {
        loadingID = [String(field.value)];
      }

      if (['package', 'product'].includes(field.type) && !loadingID) {
        loadingID = [String(field.value)];
      }

      return {
        type: field.type,
        id: loadingID,
      };
    })
    .filter(Boolean);
};
